import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      minHeight: "100vh",
      display: "grid",
      gridTemplateColumns: "1fr",
      gridTemplateRows: "1fr auto",
    },
    main: {
      paddingTop: theme.sizes.mobile.header.height,
      [theme.breakpoints.up("tablet")]: {
        paddingTop: theme.sizes.desktop.header.height,
      },
    },
    "@global *": {
      minWidth: 0,
      minHeight: 0,
    },
    "@global #simple-popper": {
      zIndex: theme.zIndex.tooltip,
    },
  }),
  { name: "UserLayout" },
);
